import Vue from 'vue'
import Vuex from 'vuex'
import {
  localRead,
  localSave
} from '@/libs/util'
Vue.use(Vuex)
//import { Message } from 'iview'

function normalizeLang(lang) {
  const rawValue = String(lang == null ? '' : lang).trim()
  const value = rawValue.toUpperCase()
  if (value === 'EN' || value === 'EN-US' || value === 'EN_US' || value === 'ENGLISH') return 'EN'
  if (value === 'YN' || value === 'ZH-TW' || value === 'ZH_TW' || value === 'ZH-HANT' || value === 'ZH_HANT' || rawValue === '繁体' || rawValue === '繁體' || rawValue === '繁体中文' || rawValue === '繁體中文') return 'YN'
  return 'CN'
}

export default new Vuex.Store({
  state: {
    isShowingLeftLayout:true,//是否显示侧边栏
 
    wsUrl:'wss://https://www.manalogy.com/xuper_api/',
    //nasUrl:'http://nas.manalogy.com:8086/material/' ,
    nasUrl:'https://nas.manalogy.com:8088/material/' ,
    //repUrl:'https://www.manalogy.com:9000/FR/ReportServer?reportlet=/Reports/' ,
    repUrl:'/FR/ReportServer?reportlet=/Reports/' ,
    local: localRead('local'),
    skin:localRead('skin'),
    showAiChat:false,
    lang: normalizeLang(sessionStorage.getItem('lang')),
    menuTitleMap:{},//菜单路径对应的多语言标题
    tabs:new Array<any>()//在右侧内容区域应当显示的tab页集合
    
  },
  mutations: {
    toggleLeftLayout(state){
      state.isShowingLeftLayout=!state.isShowingLeftLayout
    },
    newTab(state,tabObj){
      state.tabs.push(tabObj)
    },
    closeTab(state,path){
      state.tabs=state.tabs.filter(item=>item.path!==path);
    },
    updateTab(state,tabObj){
      state.tabs.map(item=>{
        if(item.path===tabObj.path){
          item.componentName=tabObj.componentName;
          item.title=tabObj.title;
          item.keepAlive=tabObj.keepAlive;
          item.query=tabObj.query;
          item.params=tabObj.params;
        }
        return item;
      });
    },
    closeAllTabs(state){
      state.tabs=[];
    },
    keepAliveTab(state,data){
      state.tabs.map(item=>{if(item.path===data.path){item.keepAlive=data.keepAlive;}return item;});
    },
    setLocal (state, lang) {
      state.lang = normalizeLang(lang)
      sessionStorage.setItem('lang', state.lang)
    },
    setMenuTitleMap (state, titleMap) {
      state.menuTitleMap = titleMap || {}
    },
    setSkin (state, skin) {
      localSave('skin', skin)
      state.skin = skin
    },
    SET_SHOW_AI_CHAT(state, val) {
      state.showAiChat = val
    }
  },
  actions: {
        // 登录

  },
  modules: {
  }
})
